/**
 * Subanta enum string values — aligned with Nest/TypeORM entity
 * (`subanta.entity.ts`): Linga, Vyutpanna, Prakar, Shreni, Barga, Bachan, Vedic.
 */

export const SUBANTA_LINGA = [
  'alinga',
  'samalinga',
  'pumalinga',
  'stri_linga',
  'napumsak_linga',
  'trilinga',
  'pumalinga_stri_linga',
  'pumalinga_napumsak_linga',
  'stri_linga_napumsak_linga',
] as const;

export const SUBANTA_VYUTPANNA = ['vyutpanna', 'avyutpanna', 'rudh', 'kriyapada'] as const;

export const SUBANTA_PRAKAR = [
  'adanata',
  'annanta',
  'aakaranta',
  'ikaranta',
  'innata',
  'iikaranta',
  'ukaranta',
  'uukaranta',
  'ridanta',
  'lridanta',
  'ekaranta',
  'aikaranta',
  'okaranta',
  'aukaranta',
  'kakaranta',
  'gakaranta',
  'ngakaranta',
  'chakaranta',
  'jakaranta',
  'takaranta',
  'ttakaranta',
  'dahkaranta',
  'dakaranta',
  'dhakaranta',
  'pakaranta',
  'phakaranta',
  'bhakaranta',
  'makaranata',
  'refanta',
  'lakaranta',
  'vakaranta',
  'shakaranta',
  'shahkaranta',
  'sakaranta',
  'hakaranta',
  'lriidanta',
] as const;

export const SUBANTA_SHRENI = ['samanya', 'madhyam', 'kathin', 'atikathin', 'paribhashik'] as const;

export const SUBANTA_BARGA = [
  'avyaya',
  'naam',
  'pratyaya',
  'visheshan',
  'sarvanam',
  'sanvanamvisheshan',
] as const;

export const SUBANTA_BACHAN = [
  'kriyapada',
  'pratyaya',
  'avyaya',
  'ekbachan',
  'duibachan',
  'bahubachan',
  'ekbachan_duibachan',
  'ekbachan_bahubachan',
  'duibachan_bahubachan',
  'ekbachan_duibachan_bahubachan',
] as const;

/** String values match `Vedic` in `subantaApi.ts`. */
export const SUBANTA_VEDIC = ['laukik', 'samas', 'ayatit', 'nirmit'] as const;

export function enumToOptions<T extends readonly string[]>(
  values: T
): { label: string; value: T[number] }[] {
  return values.map((v) => ({ label: v, value: v }));
}
